

<div class="wallet-page bg-[#f6f7fb] py-4">

    <div class="grid gap-4 lg:grid-cols-[280px_minmax(0,1fr)]">

        <!-- LEFT SIDE -->

        <div class="mb-4 lg:col-span-1">

            <!-- Wallet Card -->

            <div class="wallet-card-main">

                <div class="text-sm font-medium text-white/90">
                    Wallet Balance
                </div>

                <h1 class="balance">
                    ₹{{this.totalBalance | number:'1.2-2'}}
                </h1>

                <p class="text-sm text-white/80">Available to use</p>

                <hr class="my-4 border-white/25">

                <small class="text-white/80">Total Cashback Earned</small>

                <h3 class="mt-1 text-2xl font-semibold">
                    ₹{{this.totalCredit | number:'1.2-2' }}
                </h3>

            </div>

            <!-- Sidebar -->

            <div class="sidebar-card mt-4">

                <div class="menu"
                     [ngClass]="activePage === 'overview' ? 'active' : ''"
                     (click)="showOverview()">
                    <i class="fas fa-wallet mr-2"></i>
                    Wallet Overview
                </div>

                <div class="menu"
                     [ngClass]="activePage === 'transactions' ? 'active' : ''"
                     (click)="showTransactions()">
                    <i class="fas fa-history mr-2"></i>
                    Transactions
                </div>

                <div class="menu"
                     [ngClass]="activePage === 'cashback' ? 'active' : ''"
                     (click)="showCashback()">
                    <i class="fas fa-gift mr-2"></i>
                    Cashback Offers
                </div>

            </div>

        </div>

        <!-- RIGHT SIDE -->
        <!-- wallet overview -->
        <div class="lg:col-span-1" *ngIf="activePage=='overview'">

            <h2 class="mb-4 text-2xl font-bold">
                My Wallet Overview
            </h2>

            <!-- Summary -->

            <div class="grid gap-3 md:grid-cols-3">

                <div class="mb-3">

                    <div class="summary-card">

                        <div class="icon">
                            💰
                        </div>

                        <p class="font-bold text-gray-900">Wallet Balance</p>

                        <h2>₹{{this.totalBalance | number:'1.2-2'}}</h2>

                        <small class="text-gray-500">Ready to use</small>

                    </div>

                </div>

                <div class="mb-3">

                    <div class="summary-card">

                        <div class="icon">
                            🎁
                        </div>

                        <p class="font-bold text-gray-900">Total Cashback</p>

                        <h2 class="green">
                            ₹{{this.totalCredit | number:'1.2-2' }}
                        </h2>

                        <small class="text-gray-500">Rewards Earned</small>

                    </div>

                </div>

                <div class="mb-3">

                    <div class="summary-card">

                        <div class="icon">
                            🛒
                        </div>

                        <p class="font-bold text-gray-900">Wallet Spent</p>

                        <h2 class="text-red-600">
                            ₹{{totalDebit | number:'1.2-2'}}
                        </h2>

                        <small class="text-gray-500">On Orders</small>

                    </div>

                </div>

            </div>

            <!-- Transactions -->

            <div class="transaction-card mt-4">

                <div class="header">
                    <h4 class="text-lg font-bold">Recent Transactions</h4>
                </div>

                <div class="transaction" *ngFor="let item of rewardHistory">

                    <!-- Left Side -->

                    <div class="left">

                        <div class="icon-box"
                             [ngClass]="item.type == 'Credit' ? 'credit-bg' : 'debit-bg'">

                            <i class="fas"
                               [ngClass]="item.type == 'Credit' ? 'fa-arrow-up' : 'fa-arrow-down'">
                            </i>

                        </div>

                        <div>

                            <div class="title font-bold">
                                {{item.description}}
                                <span class="badge cashback" *ngIf="item.type=='Credit'">
                                    Cashback
                                </span>
                            </div>

                            <div class="sub-title text-sm text-gray-500">
                                {{item.order_Id}}
                            </div>

                        </div>

                    </div>

                    <!-- Right Side -->

                    <div class="right text-right">

                        <div [ngClass]="item.type == 'Credit' ? 'amount-credit' : 'amount-debit'">
                            {{ item.type == 'Credit' ? '+' : '-' }}₹{{ item.reward }}
                        </div>

                        <small class="text-gray-500">
                            {{item.createdAt | date:'dd MMM yyyy, hh:mm a'}}
                        </small>

                    </div>

                </div>

                <div class="py-5 text-center text-gray-500" *ngIf="rewardHistory.length==0">
                    No Transactions Found
                </div>

            </div>

        </div>

        <!-- transaction -->
        <div class="lg:col-span-1" *ngIf="activePage=='transactions'">

            <div class="mb-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">

                <h2 class="text-2xl font-bold">
                    Transaction History
                </h2>

                <div class="flex flex-wrap items-center gap-2">
<div>
    <p></p>
                    <button class="rounded-md px-4 py-2 text-sm font-semibold transition"
                            [ngClass]="selectedFilter == 'All' ? 'bg-[#7B68EE] text-white' : 'border border-gray-300 bg-white text-gray-600 hover:border-[#7B68EE] hover:text-[#7B68EE]'"
                            (click)="filterType('All')">
                        All
                    </button>

                    <button class="rounded-md px-4 py-2 text-sm font-semibold transition"
                            [ngClass]="selectedFilter == 'Credit' ? 'bg-[#7B68EE] text-white' : 'border border-gray-300 bg-white text-gray-600 hover:border-[#7B68EE] hover:text-[#7B68EE]'"
                            (click)="filterType('Credit')">
                        Credits
                    </button>

                    <button class="rounded-md px-4 py-2 text-sm font-semibold transition"
                            [ngClass]="selectedFilter == 'Debit' ? 'bg-[#7B68EE] text-white' : 'border border-gray-300 bg-white text-gray-600 hover:border-[#7B68EE] hover:text-[#7B68EE]'"
                            (click)="filterType('Debit')">
                        Debits
                    </button>
                    </div>

<div>

    <p>From</p>
    <input type="date"
           class="w-[170px] rounded-md border border-gray-300 bg-white px-3 py-2 text-sm outline-none focus:border-[#7B68EE]"
           [(ngModel)]="fromDate"
           (change)="applyFilter()">
</div>
<div>

<p>To</p>
                    <input type="date"
                           class="w-[170px] rounded-md border border-gray-300 bg-white px-3 py-2 text-sm outline-none focus:border-[#7B68EE]"
                           [(ngModel)]="toDate"
                           (change)="applyFilter()">

                </div>
                </div>

            </div>

            <!-- Summary -->

            <div class="mb-4 grid gap-3 md:grid-cols-2">

                <div class="summary-card bg-[#e8f7ef]">

                    <small class="font-bold text-gray-700">Total Credits</small>

                    <h2 class="text-emerald-600">
                        ₹{{totalCredit | number:'1.2-2' }}
                    </h2>

                </div>

                <div class="summary-card bg-[#fdecec]">

                    <small class="font-bold text-gray-700">Total Debits</small>

                    <h2 class="text-red-600">
                        ₹{{totalDebit | number:'1.2-2'}}
                    </h2>

                </div>

            </div>

            <!-- Table -->

            <div class="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">

                <div class="overflow-x-auto">

                    <table class="min-w-full align-middle text-sm">

                        <thead class="bg-gray-50 text-left text-gray-600">

                            <tr>

                                <th class="px-4 py-3 font-semibold">Date</th>
                                <th class="px-4 py-3 font-semibold">Description</th>
                                <th class="px-4 py-3 font-semibold">Status</th>
                                <th class="px-4 py-3 font-semibold">Amount</th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr *ngFor="let item of rewardHistory" class="border-t border-gray-200">

                                <td class="px-4 py-3">
                                    {{item.expiryDate | date:'dd MMM yyyy, hh:mm a'}}
                                </td>

                                <td class="px-4 py-3">
                                    <b>{{item.description}}</b>
                                    <br>
                                    <small class="text-gray-500">
                                        {{item.order_Id}}
                                    </small>
                                </td>

                                <td class="px-4 py-3">
                                    <span class="rounded-full px-3 py-1 text-xs font-semibold"
                                          [ngClass]="item.type=='Credit' ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'">
                                        {{item.type}}
                                    </span>
                                </td>

                                <td class="px-4 py-3">
                                    <span class="font-bold"
                                          [ngClass]="item.type=='Credit' ? 'text-emerald-600' : 'text-red-600'">
                                        {{item.type=='Credit'?'+':'-'}}₹{{item.reward}}
                                    </span>
                                </td>

                            </tr>

                        </tbody>

                    </table>

                </div>

            </div>

        </div>

        <!-- cashback -->
        <div class="lg:col-span-1" *ngIf="activePage=='cashback'">

            <div class="mb-4 flex items-center justify-between">
                <h2 class="text-2xl font-bold">
                    Cashback Offers & Rewards
                </h2>
            </div>

            <!-- Banner -->

            <div class="cashback-banner mb-4" *ngIf="cashbackHistory.length">

                <div class="grid items-center gap-4 md:grid-cols-[1fr_auto]">

                    <div>

                        <span class="offer-tag">
                            ⚡ INSTANT CASHBACK
                        </span>

                        <h2 class="mt-3 text-2xl font-semibold">
                            Use Coupon
                            <span class="text-yellow-300">
                                {{cashbackHistory[0].code}}
                            </span>
                        </h2>

                        <h1 class="mt-3 text-4xl font-bold">
                            Get
                            <span class="text-yellow-300">
                                {{cashbackHistory[0].discount}}
                                <span *ngIf="cashbackHistory[0].discountType=='percentage'">%</span>
                            </span>
                            Cashback
                        </h1>

                        <p class="mt-2 text-white/90">
                            Coupon valid till
                            {{cashbackHistory[0].expiryDate | date:'dd MMM yyyy'}}
                        </p>

                        <button class="mt-4 rounded-md bg-white px-4 py-2 text-sm font-semibold text-[#7B68EE]">
                            Apply Coupon
                        </button>

                    </div>

                    <div class="text-center">

                        <div class="cashback-price">

                            <i class="fas fa-gift fa-3x mb-3"></i>

                            <h1>
                                {{cashbackHistory[0].discount}}
                                <span>{{ cashbackHistory[0].discountType === 'percentage' ? '%' : '₹' }}</span>
                            </h1>

                            <small>Cashback</small>

                        </div>

                    </div>

                </div>

            </div>

            <!-- Cards -->
            <div class="grid gap-4 lg:grid-cols-2">

                <div class="offer-card green-card" *ngFor="let item of cashbackHistory; let i=index">

                    <div class="offer-header flex items-start justify-between">

                        <div class="flex items-start gap-3">

                            <div class="icon-box">
                                <i class="fas"
                                   [ngClass]="{
                                   'fa-shopping-cart':i%3==0,
                                   'fa-gift':i%3==1,
                                   'fa-box':i%3==2
                                   }">
                                </i>
                            </div>

                            <div>

                                <h5 class="mb-2 font-bold">
                                    {{item.discount}}
                                    <span>{{ item.discountType == 'percentage' ? '%' : '₹' }}</span>
                                    Cashback Offer
                                </h5>

                                <span class="offer-badge">
                                    Active Offer
                                </span>

                            </div>

                        </div>

                    </div>

                    <hr class="border-gray-200">
                    <h6 class="mt-2 px-5 text-sm font-bold text-gray-800">{{item.title}}</h6>
                    <h6 class="mt-2 px-5 text-sm font-bold text-emerald-600">{{item.code}}</h6>
                    <p class="offer-text mt-2">
                        Use coupon
                        <b>{{item.code}}</b>
                        while placing your order and get instant cashback.
                    </p>

                    <div class="my-2 flex items-center justify-between px-5 pb-4">

                        <div class="cashback-pill">
                            + {{item.discount}}
                            <span>{{ item.discountType == 'percentage' ? '%' : '₹' }}</span>
                            Cashback
                        </div>

                        <button class="shop-btn" routerLink="/">
                            Shop Now
                        </button>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>


